import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-history',
  templateUrl: './our-history.component.html',
  styleUrls: ['./our-history.component.scss']
})
export class OurHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
